// @ts-strict-ignore
import { BehaviorSubject, Subject } from 'rxjs';
import { TableData, TableRow } from './types';

export class TableService {
  data: BehaviorSubject<TableData> = new BehaviorSubject({ rows: [], columns: [] });
  decimals: number = 4;
  editedRow: Subject<{ rows: TableRow[] }> = new Subject();
  isLeftColumnHeading: boolean = false;
  showFalseIcon: boolean = true;

  clearTable() {
    const rows: TableRow[] = [];
    this.data.getValue().rows.forEach((row) => {
      this.data.getValue().columns.forEach((col) => {
        if (col.editable) {
          row.data[col.id] = '';
        }
      });
      rows.push(row);
    });
    this.data.next({ rows: rows, columns: this.data.getValue().columns });
    this.editRow(rows);
  }
  editRow(editedRow: TableRow[]) {
    this.editedRow.next({ rows: editedRow });
  }
}
